import React, {
  useRef, useEffect, useContext, useState,
} from 'react';
import { Link, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from '@common/hooks/translation';
import IdleService from '@common/services/idle';
import { useDataFetch } from '@common/hooks/dataFetch';
import CMSApi from '@app/dev/services/cmsApi';
import Config from '@skin_config';
import { HandleMousePosition } from '@app/dev/actions/terminal';
import { PreferencesContext } from '@common/contexts/preferences';
import { getCasinoGameURL, updateLastPlayedGames } from '@app/dev/terminal/containers/casino/helpers';

// const casinoTypeConfig = {
//   'liveCasino': {
//     gamesLoader: CMSApi.getLiveCasinoGames
//   },
//   casino: {
//     gamesLoader: CMSApi.getCasinoGames
//   }
// }
// const config = casinoTypeConfig[routePath]

export const GameDetails = ({ id: idProp, routePath, isFullScreenGame }) => {
  const { id: idSearchParam } = useParams();
  const t = useTranslation();
  const iframeRef = useRef(null);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const gameId = idProp || idSearchParam;

  const [{ lang }] = useContext(PreferencesContext);
  const gamesLoader = routePath === '/liveCasino' ? CMSApi.getLiveCasinoGames : CMSApi.getCasinoGames;
  const [data] = useDataFetch(() => gamesLoader({ id: gameId }), [gameId]);
  const [isFullscreen, setIsFullscreen] = useState(Config.casino.gameOpenFullscreen === 'automatic');

  const game = data?.games?.[0];
  const gameUrl = game && getCasinoGameURL(game, user, lang);

  useEffect(() => {
    if (game && gameUrl) updateLastPlayedGames({ game, gameUrl, routePath });
  }, [game, gameUrl, routePath]);

  useEffect(() => {
    if (Config.main.unfocusForInactivity) {
      const intervalId = setInterval(() => {
        const iframe = iframeRef.current;
        const { activeElement } = document;

        if (activeElement === iframe) {
          activeElement.blur();
          IdleService.resetTimer();
          dispatch(HandleMousePosition({ x: 0, y: 0 }));
        }
      }, 2000);

      return () => clearInterval(intervalId);
    }
  }, [dispatch]);

  useEffect(() => {
    if (!Config.main.unfocusForInactivity && gameUrl && iframeRef.current && document.activeElement !== iframeRef.current) {
      setTimeout(() => iframeRef.current?.focus(), 0);

      const onBlur = () => setTimeout(() => iframeRef.current?.focus(), 0);

      iframeRef.current.addEventListener('blur', onBlur);

      return () => {
        iframeRef.current?.removeEventListener('blur', onBlur);
      };
    }
  }, [gameUrl, iframeRef]);

  return (
    <div className={`game-container ${isFullScreenGame && 'fullScrrenGame'}`}>
      {routePath && (
      <Link to={routePath} className="close-game-button">
        <i className="global-icon icon-arrow-line-left" />
        {t('Back to Games')}
      </Link>
      )}
      {/* {game?.background ? (
        <img src={game?.background} alt="game background" className="added-img" />
      ) : (
        <div className="background-img"> </div>
      )} */}
      <div className="game-iframe-wrapper " style={{ background: `url(${game?.background})` }}>
        <div className={`game-iframe-container ${isFullscreen ? 'game-iframe-container-fullscreen' : ''}`}>
          {Config.casino.gameOpenFullscreen && (
            <i
              className={`game-iframe-fullscreen-toggle global-icon ${isFullscreen ? 'icon-fullscreen-exit' : 'icon-fullscreen'}`}
              onClick={() => setIsFullscreen(!isFullscreen)}
            />
          )}
          {gameUrl && (
          <iframe
            title="Casino game"
            ref={iframeRef}
            src={gameUrl}
          />
          )}
        </div>
      </div>
    </div>
  );
};

GameDetails.propTypes = {
  id: PropTypes.string,
  routePath: PropTypes.string,
  isFullScreenGame: PropTypes.bool,
};
